import { ReactNode } from 'react'
import { faClose } from '@fortawesome/pro-regular-svg-icons'
import {
  ImageBackgroundColors,
  mtc,
  TypographyStyles,
} from '../../../utils/style-helpers'
import { Button } from '../../atoms/button'
import { Card, CardColors } from '../../atoms/card'
import { Heading, HeadingVariants } from '../../atoms/heading'
import { Image } from '../../atoms/image'
import { Text } from '../../atoms/text'
import { bodyStyles, imgBgStyles, styles } from './styles'

export enum CardVariants {
  DEFAULT = 'default',
  STACK = 'stack',
  ANNOUNCEMENT = 'announcement',
  LEFT_ALIGNED = 'left',
}

interface IHeroCardProps {
  children?: ReactNode
  className?: string
  color?: CardColors
  description?: ReactNode
  imageAlt: string
  imageColor?: ImageBackgroundColors
  imageSrc: string
  imageWidth?: number
  onClose?: () => void
  subheader?: ReactNode
  title: string
  variant?: CardVariants
}

export const HeroCard = ({
  children,
  className,
  color,
  description,
  imageAlt,
  imageColor,
  imageSrc,
  imageWidth,
  onClose,
  subheader,
  title,
  variant,
}: IHeroCardProps) => {
  return (
    <Card
      className={className}
      color={color}
      childrenClassName={mtc(styles({ variant }))}
    >
      {variant === CardVariants.LEFT_ALIGNED && (
        <div className="flex flex-col sm:flex-row items-center">
          <div className={mtc(imgBgStyles(), imageColor)}>
            <Image
              alt={imageAlt}
              width={imageWidth}
              src={imageSrc}
              objectFit="scaleDown"
            />
          </div>

          <div className={mtc(bodyStyles({ variant }))}>
            <header>
              <Heading
                variant={HeadingVariants.H4}
                className="text-neutral-500"
              >
                {subheader}
              </Heading>
              <Heading
                variant={HeadingVariants.H1}
                className="text-neutral-900"
              >
                {title}
              </Heading>
            </header>
            {description && (
              <Text
                variant={TypographyStyles.BODY_MD}
                className="text-neutral-600"
              >
                {description}
              </Text>
            )}

            {children}
          </div>
        </div>
      )}

      {variant !== CardVariants.LEFT_ALIGNED && (
        <>
          <div className={mtc(imgBgStyles(), imageColor, 'hidden sm:flex')}>
            <Image
              alt={imageAlt}
              width={imageWidth}
              src={imageSrc}
              objectFit="scaleDown"
            />
          </div>

          <div className={mtc(bodyStyles())}>
            <header>
              <Heading
                variant={HeadingVariants.H4}
                className="text-neutral-500"
              >
                {subheader}
              </Heading>
              <Heading
                variant={HeadingVariants.H1}
                className="text-neutral-900"
              >
                {title}
              </Heading>
            </header>
            {description && (
              <Text
                variant={TypographyStyles.BODY_MD}
                className="text-neutral-600"
              >
                {description}
              </Text>
            )}

            {children}
          </div>
        </>
      )}

      {onClose && (
        <Button
          aria-label="dismiss card"
          className="text-neutral-500 absolute top-3 right-3"
          iconRight={faClose}
          onClick={onClose}
          variant="discreet"
          size="square"
        />
      )}
    </Card>
  )
}
